import { createContext, useContext, ReactNode } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface LanguageContextType {
  currentLanguage: string;
  currentMarket: string;
  changeLanguage: (lang: string) => void;
  availableLanguages: Array<{ code: string; name: string; market: string }>;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

// Hardcoded to Swedish only
const LANGUAGES = [
  { code: 'sv-SE', name: 'Svenska', market: 'SE' },
];

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Always return Swedish
  const currentLanguage = 'sv-SE';
  const currentMarket = 'SE';

  const changeLanguage = (lang: string) => {
    // Keep for API compatibility but do nothing
    console.log('Language switching disabled - Swedish only');
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLanguage,
        currentMarket,
        changeLanguage,
        availableLanguages: LANGUAGES,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
